// A focused <input type="number"> changes its value when the mouse wheel turns over it. Users type a number in a modal
// (e.g. a game duration of 90) and scroll down to Save, and the wheel quietly lowers what they typed. When the wheel turns
// over a focused number input, the input loses focus first: its value stays and the page or modal scrolls as expected.
// Typing and the arrow keys keep working.

export function blurFocusedNumberInput (event) {
  const input = event.target

  if (input instanceof HTMLInputElement && input.type === 'number' && input === document.activeElement) {
    input.blur()
  }
}

// Listens on the whole document (capture phase, before the browser's default action), so it covers every number input,
// formly fields and plain inputs alike. Returns a function that removes the listener.
export function disableNumberInputWheel (target = document) {
  const options = { capture: true, passive: true }

  target.addEventListener('wheel', blurFocusedNumberInput, options)

  return () => target.removeEventListener('wheel', blurFocusedNumberInput, options)
}
